import React, { useState } from "react";
import logo from "../../images/logo.png";
import { LuMenu, LuX } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const menu = [
  {
    name: "Free Bet codes",
    path: "/",
  },
  {
    name: "My Bets",
    path: "/mybets",
  },
  {
    name: "Login",
    path: "/login",
  },
  {
    name: "Get started",
    path: "/signup",
  },
];

export const MobileNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleActive = (id, path) => {
    setActive(id);
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <div className="landing-row px-0 py-3">
      <div className="flex justify-between items-center">
        <img
          src={logo}
          className="img-fluid logo"
          alt="logo"
          style={{
            height: "50px",
            width: "auto",
            maxWidth: "160px",
            objectFit: "contain",
          }}
        />

        <div className="mt-1 cursor-pointer" onClick={toggleMenu}>
          {menuOpen ? <LuX size={32} /> : <LuMenu size={32} />}
        </div>
      </div>

      {menuOpen && (
        <div className="bg-[#FFF] w-full mt-4 rounded-md">
          {menu.map((elem, index) => (
            <p
              onClick={() => handleActive(index, elem.path)}
              key={index}
              className={
                active === index
                  ? "mt-3 text-[#7E00CC] text-[18px] font-medium cursor-pointer"
                  : "mt-3 text-[#2B4255] text-[18px] font-medium cursor-pointer"
              }
            >
              {elem.name}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};